import { BOTTOM_NAVS } from '@constants/utils';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  errorLP: null,
  preorderError: null,
  info: null,
  onOk: null,
  alert: null,
  lang: localStorage.getItem('i18nextLng')?.toLowerCase(),
  rerender: false,
  openInquiry: false,
  openForm: false,
  activeNav: BOTTOM_NAVS.HOME,
  selectedStore: null,
  originalPath: null
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setPreorderError: (state, { payload }) => {
      state.preorderError = payload;
    },
    setErrorLP: (state, { payload }) => {
      state.error = payload;
    },
    setInfo: (state, { payload }) => {
      state.info = payload;
    },
    setOnOk: (state, { payload }) => {
      state.onOk = payload;
    },
    setLang: (state, { payload }) => {
      state.lang = payload;
    },
    setRerender: (state, { payload }) => {
      state.rerender = payload;
    },
    setAlert: (state, { payload }) => {
      state.alert = payload;
    },
    setInquiry: (state, { payload }) => {
      state.openInquiry = payload;
    },
    setOpenForm: (state, { payload }) => {
      state.openForm = payload;
    },
    setSelectedStore: (state, { payload }) => {
      state.selectedStore = payload;
    },
    setActiveNav: (state, { payload }) => {
      state.activeNav = payload;
    },
    setOriginalPath: (state, { payload }) => {
      state.originalPath = payload;
    }
  }
});

export const {
  setLoading,
  setActiveNav,
  setPreorderError,
  setInfo,
  setOnOk,
  setLang,
  setRerender,
  setInquiry,
  setAlert,
  setErrorLP,
  setOpenForm,
  setSelectedStore,
  setOriginalPath
} = appSlice.actions;

export default appSlice.reducer;
